import { render, staticRenderFns } from "./ScholarSearch.vue?vue&type=template&id=1f9a2d70&scoped=true&"
import script from "./ScholarSearch.vue?vue&type=script&lang=js&"
export * from "./ScholarSearch.vue?vue&type=script&lang=js&"
import style0 from "../assets/v2/css/trans/common.less?vue&type=style&index=0&id=1f9a2d70&prod&lang=less&scoped=true&"
import style1 from "./ScholarSearch.vue?vue&type=style&index=1&id=1f9a2d70&prod&lang=less&scoped=true&"
import style2 from "./ScholarSearch.vue?vue&type=style&index=2&id=1f9a2d70&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a2d70",
  null
  
)

export default component.exports